import React, { useEffect, useMemo, useState } from 'react';
import { selectValByCondition } from '@home/utils/common';
import SingleSelect from '@home/components/SingleSelect';
import { getCountryFlag } from '@home/_config/countries';
import { IFilterOption } from '../useData';
import classNames from 'classnames';
import '@/pages/benchmark/assets/scss/page/genre/components/MetricTable.scss';

export interface IPlatformFilterProps {
  options: IFilterOption[];
  value?: string;
  isEN: boolean;
  locale: "zh-CN" | "en-US";
  onChange: (value: string) => void;
}

const RegionCountryFilter = (props: IPlatformFilterProps) => {
  const { options, value: propsValue, onChange, isEN, locale } = props;

  const [value, setValue] = useState<string>();

  useEffect(() => {
    if (propsValue) {
      setValue(propsValue);
    }
  }, [propsValue]);

  // 组装国家数据
  const newOptons = useMemo(() => {
    const newCountryOpts = options?.map(
      (item) => {
        const { name_en, name_ch, code } = item;
        return {
          value: code,
          text: selectValByCondition(isEN, name_en, name_ch),
          icon: getCountryFlag(code),
          info:
            code === 'global'
              ? selectValByCondition(
                isEN,
                'All represents the total aggregated data for all the respective countries.',
                'All表示当前对应国家列表的全部数据汇总。',
              )
              : '',
        };
      },
    );
    return newCountryOpts;
  }, [options, isEN]);

  const handlChange = (value: string) => {
    setValue(value);
    onChange?.(value);
  };

  return (
    <div className="dbb-genre-benchmark-filter-col">
      <div className={classNames({ 'is-en': isEN })}>{selectValByCondition(isEN, 'Region/Country', '区域/国家')}</div>
      <SingleSelect options={newOptons} value={value} onChange={handlChange} locale={locale} />
    </div>
  );
};
export default RegionCountryFilter;
